<template>
  <div class="genmanipulted-substances">
    <div class="row">
      <div
        class="wrapperSmokeContainsToxicMutagenicSubstances text-left col-sm-10 col-md-8 offset-1"
      >
        <h3
          class="smokeheadlineh3 wow fadeInLeft"
          v-html="$t('smoke_contains_toxic_mutagenic_substances')"
        ></h3>
      </div>
    </div>

    <div class="genmanipulted-substances__items">
      <EnumerationWithArrow
        :arrowFunction="unhide"
        :enumerationStrings="enumerationStrings"
        scrollToArgument="magic2"
      />
    </div>
    <div class="container d-none d-md-block">
      <div class="row">
        <div class="wrapperVirusBallImage col-3 offset-9">
          <img
            class="img-responsive wow fadeInRightBig"
            src="@/assets/images/balls.png"
          />
        </div>
      </div>
    </div>

    <div class="container d-none d-md-block virenbox wow fadeInUpBig">
      <div id="magic2"></div>
      <div class="row"></div>
    </div>

    <Slider v-bind:isActive="isSliderActive" />
  </div>
</template>

<script>
import EnumerationWithArrow from "@/components/EnumerationWithArrow";
import Slider from "./Slider";
export default {
  name: "GenmanipulatedSubstances",
  components: {
    Slider,
    EnumerationWithArrow
  },
  data() {
    return {
      enumerationStrings: ["bacteria", "viruses", "particles"],
      isSliderActive: false
    };
  },
  methods: {
    unhide() {
      return (this.isSliderActive = !this.isSliderActive);
    }
  }
};
</script>

<style scoped>
.wrapperSmokeContainsToxicMutagenicSubstances {
  margin-bottom: 30px;
  margin-top: 100px;
}

.wrapperVirusBallImage {
  margin-top: -200px;
}

.genmanipulted-substances__items {
  padding-bottom: 70px;
}
</style>
